<ng-container *ngIf="blocksConfig?.editable; else readonlyTable">
  <app-dropdown #toolbarDropdown
                placement="top-start"
                elevation="4"
                hideMethod="ngif"
                [externalTarget]="table"
                [renderPanelInBody]="true"
                [hideOnInnerClick]="false"
                [hideOnOuterClick]="false"
                [flip]="false"
                [preventOverflow]="true"
                [offsetTop]="true"
                [offset]="20"
                [preventOverflowBoundaryElement]="scrollingContainer || 'clippingParents'">
    <app-rich-text-toolbar
      #toolbar
      [state]="accumulatedRteState"
      [richTextBlockIds]="selectedRichTextIds"
      [selectAll]="!cellSelection?.isSingleCellSelection"
      [showVariableButton]="cellSelection?.isSingleCellSelection"
      [variables]="variables"
      [selectedText]="selectedText"
      (close)="cellSelection = null; toolbarDropdown.hide()">
    </app-rich-text-toolbar>
  </app-dropdown>

  <table class="table w-100 table-bordered"
         #table
         #cellSelectable="cellSelectable"
         #movable="movable"
         #addDelete="addDelete"
         #resizeColumns="resizeColumns"
         (colAdded)="fixColSizes(table.offsetWidth)"
         (rowAdded)="fixColSizes(table.offsetWidth)"
         (colRemoved)="fixColSizes(table.offsetWidth)"
         [cellSelectable]="blockSelected"
         [movable]="blockSelected"
         [addDelete]="blockSelected"
         [resizeColumns]="blockSelected"
         copyPaste
         [class.table-header]="block.settings.header"
         [class.table-footer]="block.settings.footer"
         [class.table-header-column]="block.settings.headerColumn"
         [class.table-border-outline]="block.settings.outline"
         [class.table-border-horizontal]="block.settings.horizontalBorders"
         [class.table-border-vertical]="block.settings.verticalBorders"
         [style.--table-border-width]="block.settings.borderWidth + 'px'"
         [style.--table-border-color]="block.settings.borderColor"
         [class.blockSelected]="blockSelected"
         [class.resize-col]="resizeColumns.primaryNewWidth != null || resizeColumns.secondaryNewWidth != null">

    <tr *ngFor="let row of children; first as firstRow; last as lastRow; index as rowIndex">
      <ng-container *ngFor="let cell of row.children; first as firstCol; last as lastCol; index as colIndex">
        <td #cellElement
            [style.width.%]="getColumnWidth(colIndex)"
            [style.backgroundColor]="$any(cell.settings).backgroundColor"
            [style.paddingLeft.px]="block.settings.cellPadding.left"
            [style.paddingRight.px]="block.settings.cellPadding.right"
            [style.paddingBottom.px]="block.settings.cellPadding.bottom"
            [style.paddingTop.px]="block.settings.cellPadding.top"
            [attr.data-cellId]="cell.id" [attr.data-colIndex]="colIndex" [attr.data-rowIndex]="rowIndex"
            [class.first-col]="cellSelection?.x1 === colIndex"
            [class.last-col]="cellSelection?.x2 === colIndex"
            [class.first-row]="cellSelection?.y1 === rowIndex"
            [class.last-row]="cellSelection?.y2 === rowIndex"
            [class.selected]="cellSelection?.isCellSelected(colIndex, rowIndex)"
            (click)="cellSelectable.cellMouseClick($event)"
            (mousedown)="cellSelectable.cellMouseDown($event)"
            (mouseleave)="cellSelectable.cellMouseLeave($event)"
            (mouseenter)="cellSelectable.cellMouseEnter($event)"
            (contextmenu)="openContextMenu($event, 'cell')">

          <div *ngIf="!lastCol"
               (mousedown)="$event.button === 0 && resizeColumns.startResize(table.offsetWidth, colIndex, $event)"
               (mouseup)="tableService.mouseUp$.next($event); $event.stopPropagation()"
               (click)="$event.stopPropagation()"
               class="resize-handle"
               [attr.data-colIndex]="colIndex"></div>

          <app-table-interaction *ngIf="firstRow && blockSelected" mode="col"
                                 (contextmenu)="$event.preventDefault(); $event.stopPropagation(); openContextMenu($event, 'col'); cellSelection = null"
                                 (mousedownEvent)="movable.interactionElementMouseDown(rowIndex, colIndex, $event, 'col')"
                                 (dragHandleClicked)="openContextMenu($event, 'col')"
                                 (interactionElementClicked)="cellSelectable.selectColumn(colIndex)"
                                 [class.active]="dragging && dragStartIndex === colIndex && dragMode === 'col'">
          </app-table-interaction>

          <app-table-interaction *ngIf="firstCol && blockSelected" mode="row"
                                 (contextmenu)="$event.preventDefault(); $event.stopPropagation(); openContextMenu($event, 'row'); cellSelection = null"
                                 (mousedownEvent)="movable.interactionElementMouseDown(rowIndex, colIndex, $event, 'row')"
                                 (dragHandleClicked)="openContextMenu($event, 'row')"
                                 (interactionElementClicked)="cellSelectable.selectRow(rowIndex)"
                                 [class.active]="dragging && dragStartIndex === rowIndex && dragMode === 'row'">
          </app-table-interaction>

          <div class="cell-block">
            <app-rich-text (focused)="editorFocused(colIndex, rowIndex)"
                           (blurred)="editorBlurred(colIndex, rowIndex)"
                           (textSelected)="selectedText = $event"
                           (stateChange)="$event != null && addRteState($event)"
                           *ngFor="let rte of cell.children" [block]="rte">
            </app-rich-text>
          </div>
        </td>
      </ng-container>
    </tr>
  </table>

  <div
    *ngIf="dragging && dragMode === 'col'"
    class="drop-marker drop-marker-x"
    [style.--table-border-width]="block.settings.borderWidth + 'px'"
    [style.left]="dropCols[nearestDropColIndex] - (nearestDropColIndex + 1) + 'px'">
  </div>

  <div
    *ngIf="dragging && dragMode === 'row'"
    class="drop-marker drop-marker-y"
    [style.--table-border-width]="block.settings.borderWidth + 'px'"
    [style.top]="dropRows[nearestDropRowIndex] - (nearestDropRowIndex + 1) + 'px'">
  </div>


  <div
    *ngIf="dragging && dragMode === 'col'"
    class="drag-shadow drag-shadow-x"
    [style.left]="(dragDistance.x + dragStartOffset.x) + 'px'"
    [style.width]="dragTargetOffset + 'px'">
  </div>

  <div
    *ngIf="dragging && dragMode === 'row'"
    class="drag-shadow drag-shadow-y"
    [style.top]="(dragDistance.y + dragStartOffset.y) + 'px'"
    [style.height]="dragTargetOffset + 'px'">
  </div>

  <app-dropdown #contextDropdownComponent
                [renderPanelInBody]="true"
                [elevation]="4"
                [hideOnOuterClickTrigger]="'mousedown'"
                (closed)="currentColIndex = null; currentRowIndex = null;"
                placement="bottom-start"
                [offsetTop]="true"
                [panelClasses]="['table-context-menu']">
    <div *dropdownPanel>
      <app-dropdown-items *transloco="let t; read: 'blocks.' + block.type + '.context_menu'">
        <ng-container *ngIf="dropdownMode === 'row' || dropdownMode === 'cell'">
          <app-dropdown-item [disabled]="loading" [icon]="['far', 'table']"
                             (click)="addDelete.addRowAtIndex(currentRowIndex)">
            {{t('add_row_above')}}
          </app-dropdown-item>
          <app-dropdown-item [disabled]="loading" [icon]="['far', 'table']"
                             (click)="addDelete.addRowAtIndex(currentRowIndex + 1)">
            {{t('add_row_below')}}
          </app-dropdown-item>
          <app-dropdown-item [disabled]="loading" [icon]="['far', 'table']"
                             (click)="addDelete.removeRowAtIndex(currentRowIndex)">
            {{t('remove_row')}}
          </app-dropdown-item>
        </ng-container>

        <app-dropdown-item [disabled]="loading" *ngIf="dropdownMode === 'cell'" [divider]="true"></app-dropdown-item>

        <ng-container *ngIf="dropdownMode === 'col' || dropdownMode === 'cell'">
          <app-dropdown-item [disabled]="loading" [icon]="['far', 'table']"
                             (click)="addDelete.addColAtIndex(currentColIndex)">
            {{t('add_column_left')}}
          </app-dropdown-item>
          <app-dropdown-item [disabled]="loading" [icon]="['far', 'table']"
                             (click)="addDelete.addColAtIndex(currentColIndex + 1)">
            {{t('add_column_right')}}
          </app-dropdown-item>
          <app-dropdown-item [disabled]="loading" [icon]="['far', 'table']"
                             (click)="addDelete.removeColAtIndex(currentColIndex)">
            {{t('remove_column')}}
          </app-dropdown-item>
        </ng-container>
      </app-dropdown-items>
    </div>
  </app-dropdown>
</ng-container>

<ng-template #readonlyTable>
  <div class="table-responsive mb-3">
    <table
      class="table table-bordered mb-0"
      [class.table-header]="block.settings.header"
      [class.table-footer]="block.settings.footer"
      [class.table-header-column]="block.settings.headerColumn"
      [class.table-border-outline]="block.settings.outline"
      [class.table-border-horizontal]="block.settings.horizontalBorders"
      [class.table-border-vertical]="block.settings.verticalBorders"
      [style.--table-border-width]="block.settings.borderWidth + 'px'"
      [style.--table-border-color]="block.settings.borderColor">

      <tr *ngFor="let row of children; first as firstRow">
        <ng-container *ngFor="let cell of row.children; last as lastCol; index as colIndex">
          <td
            [style.width.%]="getColumnWidth(colIndex)"
            [style.backgroundColor]="$any(cell.settings).backgroundColor"
            [style.paddingLeft.px]="block.settings.cellPadding.left"
            [style.paddingRight.px]="block.settings.cellPadding.right"
            [style.paddingBottom.px]="block.settings.cellPadding.bottom"
            [style.paddingTop.px]="block.settings.cellPadding.top">
            <div class="cell-block">
              <app-rich-text *ngFor="let block of cell.children" [block]="block"></app-rich-text>
            </div>
          </td>
        </ng-container>
      </tr>
    </table>
  </div>
</ng-template>
